// extracted by mini-css-extract-plugin
export default {"alert-content":"Alert_alert-content__uLfCY"};